import React from 'react';

interface IProps {
  // Clears the fallback when it changes, so the browser's Back button or a link out of the broken page works.
  resetKey: string;
  children: React.ReactNode;
}

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<IProps, IState> {
  state: IState = { hasError: false };

  static getDerivedStateFromError(): IState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  componentDidUpdate(prevProps: IProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-screen tw-px-4 tw-py-8 tw-text-center tw-text-blue-900 secondary-font-family">
        <h1 className="primary-font-family tw-text-3xl tw-mb-3">Something went wrong</h1>
        <p className="tw-mb-6">Reloading the page usually fixes this.</p>
        <button type="button" className="tw-btn tw-btn-brand" onClick={() => { window.location.reload(); }}>Reload</button>
      </div>
    );
  }
}

export default ErrorBoundary;
